import { Injectable } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { AtelierDetailImmoTask } from './model/atelier-detail-immo-task';
import { AtelierDetailTourItem } from './model/atelier-detail-tour-item';
import { AtelierDetailCheckRequired } from './model/atelier-detail-check-required';
import { TourItemCheckboxes } from './model/tour-item-checkboxes';

@Injectable({
  providedIn: 'root',
})
export class AtelierTourItemHelper {
  parseItem(item: AtelierDetailTourItem): void {
    if (item.subProject != null) {
      this.parseSubProjectItem(item);
    } else if (item.immoTask != null) {
      this.parseImmoTaskItem(item);
    }
  }

  parseSubProjectItem(item: AtelierDetailTourItem): void {
    item.finished = this.isFinished(item);
    if (
      item.subProject.designPictures != null &&
      item.subProject.designPictures.length > 0
    ) {
      item.subProject.firstDesignPicture = item.subProject.designPictures[0];
    }
    if (item.subProject.project != null) {
      if (item.subProject.project.products.length > 0) {
        item.subProject.project.firstProduct =
          item.subProject.project.products[0];

        item.subProject.project.products.forEach((product) => {
          if (product.placers != null && product.placers.length > 0) {
            product.firstPlacer = product.placers[0];
          }
        });
      }
    }
  }

  isFinished(item: AtelierDetailTourItem): boolean {
    const fields: (keyof AtelierDetailCheckRequired &
      keyof TourItemCheckboxes)[] = [
      'atelierInfo',
      'configuration',
      'title',
      'phoneNumber',
      'text',
      'immoscoop',
      'spotto',
      'secondBoard',
      'arrows',
      'otherOrder',
      'extraBoard',
      'atelierExtraInfo',
      'stockAtBranch',
      'frameColor',
      'frame',
    ];
    return fields.every((field) => this.isFinishedItem(item, field));
  }

  isFinishedItem(
    item: AtelierDetailTourItem,
    field: keyof AtelierDetailCheckRequired & keyof TourItemCheckboxes
  ): boolean {
    return !item.required[field] || item.checked[field];
  }

  parseImmoTaskItem(item: AtelierDetailTourItem): void {
    item.finished = this.immoTaskIsFinished(item.immoTask);
    item.immoTask.firstDesignPicture = CollectionHelper.isPopulated(
      item.immoTask.designPictures
    )
      ? item.immoTask.designPictures[0]
      : null;
  }

  immoTaskIsFinished(immoTask: AtelierDetailImmoTask): boolean {
    if (immoTask.atelierCheckboxes == null) {
      return false;
    }
    if (
      !StringHelper.isEmpty(immoTask.description) &&
      !immoTask.atelierCheckboxes.descriptionRead
    ) {
      return false;
    }
    return immoTask.atelierCheckboxes.prepared;
  }
}
